import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { VerMapaPage } from '../vermapa/vermapa';

@Component({
  selector: 'carregando',
  templateUrl: 'carregando.html'
})
export class CarregandoPage {
	constructor(public navCtrl: NavController) {}

	ionViewDidLoad() {
		setTimeout(() => {
      		this.navCtrl.push(VerMapaPage);
    	},3000);
	}
}


// WEBPACK FOOTER //
// ./src/pages/carregando/carregando.ts